import { useState } from "react";

import { DragDropContext } from "react-beautiful-dnd";

import { Loading } from "../../../components/loading";
import MeetingRoom from "../../fullscreen/meeting-room";

import SideTabs from "./SideTabs";

const MeetingDetails = () => {
  const [loading] = useState(false);

  const { onDragStart, onDragEnd } = useDnD();

  return (
    <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
      <div className="tutorials-render sidebar-player-mode">
        {loading && <Loading />}
        <MeetingRoom />
        <SideTabs loading={loading} />
      </div>
    </DragDropContext>
  );
};

// TODO: useful work for future
function useDnD() {
  const [screens, setScreens] = useState([]);
  const [destinationsScreen, setDestinationsScreen] = useState([]);
  const [mediaUploadedItems, setMediaUploadedItems] = useState([]);
  const [isShowMusicBarTimeline, setIsShowMusicBarTimeline] = useState(false);
  const [startingSource, setStartingSource] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [runCursorState, setRunCursorState] = useState(false);

  // useEffect(() => {
  //   if (location.state && location.state.selectedItems) setScreens(location.state.selectedItems);
  // }, [location]);

  const addMovieNextScreensToEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    // put a media behind the screens like Demo in the film2
    if (source.droppableId === "media-section" && destination.droppableId === "timeline-screen-bar") {
      const a = [...destinationsScreen];
      a.push([`d${destinationsScreen.length + 1}`, [mediaUploadedItems[source.index]], []]);
      setDestinationsScreen(a);
    }
  };

  const addMovieNextScreensEveryWhereOfTimelineExeptEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    let id = [];
    id = destination.droppableId?.split("#");
    // id[0]=> "timeline-screen-bar"
    if (source.droppableId === "media-section" && destination.droppableId === `${id[0]}#${id[1]}` && id?.length === 2) {
      setDestinationsScreen((prev) => {
        const a = [...prev];
        a.splice(id[1], 0, [`d${prev.length + 1}`, [mediaUploadedItems[source.index]], []]);
        return a;
      });
    }
  };

  const addMediaToScreens = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    // find screen like d1 or d2 & ...
    const destinationIndex = destinationsScreen.findIndex((i) => i[0] === destination.droppableId);
    if (source.droppableId === "media-section" && destinationIndex !== -1) {
      const a = [...destinationsScreen];
      a[destinationIndex][2].push(mediaUploadedItems[source.index]);
      setDestinationsScreen(a);
      setIsShowMusicBarTimeline(true);
    }
  };

  const addNewScreenToEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.droppableId === "screens-section" && destination.droppableId === "timeline-screen-bar") {
      setDestinationsScreen((prev) => [...prev, [`d${prev.length + 1}`, [screens[source.index]], []]]);
    }
  };

  const addNewScreenToEveryWhereOfTimelineExeptEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    let id = [];
    id = destination.droppableId?.split("#");
    // id[0]=> "timeline-screen-bar"
    if (source.droppableId === "screens-section" && destination.droppableId === `${id[0]}#${id[1]}` && id?.length === 2) {
      setDestinationsScreen((prev) => {
        const a = [...prev];
        a.splice(id[1], 0, [`d${prev.length + 1}`, [screens[source.index]], []]);
        return a;
      });
    }
  };

  const moveMediaBetweenScreens = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    // find source-screen like d1 or d2 & ...
    const sourceIndex = destinationsScreen.findIndex((i) => i[0] === source.droppableId);

    // find destination-screen like d1 or d2 & ...
    const destinationIndex = destinationsScreen.findIndex((i) => i[0] === destination.droppableId);

    if (sourceIndex !== -1 && destinationIndex !== -1) {
      setDestinationsScreen((prev) => {
        // add to new place
        const a = [...prev];
        a[destinationIndex][2].push(a[sourceIndex][2][source.index]);

        // remove from old place
        a[sourceIndex][2].splice(source.index, 1);

        return a;
      });
    } else return;

    setIsDragging(false);
  };

  const onDragEnd = (result) => {
    addMovieNextScreensToEnd(result);
    addMovieNextScreensEveryWhereOfTimelineExeptEnd(result);
    addMediaToScreens(result);
    addNewScreenToEnd(result);
    addNewScreenToEveryWhereOfTimelineExeptEnd(result);
    moveMediaBetweenScreens(result);
    //
    console.log("onDragEnd", result);
    setStartingSource(null);
  };

  const onDragStart = (result) => {
    console.log("onDragStart", result);
    setStartingSource(result.source);
    setIsDragging(true);
  };

  const handleAddScreen = () => setDestinationsScreen((prev) => [...prev, [`d${prev.length + 1}`, []]]);

  return { onDragStart, onDragEnd };
}

export default MeetingDetails;
